module.exports = __webpack_public_path__ + "img/bird.25943eb6.svg";